module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "example-2",
      "toolbar": "",
      "footer": ""
    }
  }, [(_vm.authorized()) ? _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "5"
    },
    attrs: {
      "fixed": "",
      "persistent": "",
      "light": "",
      "mini-variant": _vm.mini,
      "overflow": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', {
    on: {
      "click": function($event) {
        _vm.$router.push('/profile')
      }
    }
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.$router.push('/profile')
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.auth.user.name) + " " + _vm._s(_vm.$store.auth.user.surname))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$store.auth.user.company && _vm.$store.auth.user.company.customLogo) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.auth.user.company.customLogo
    }
  })]) : _vm._e(), _vm._v(" "), _c('navigation', {
    ref: "navigation"
  }), _vm._v(" "), (_vm.$auth.hasRole('GROUP_ADMIN')) ? _c('delegations', {
    on: {
      "change": _vm.delegationChanged
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.authorized()) ? _c('v-toolbar', {
    staticClass: "indigo darken-4",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title()))]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('main', [_c('v-container', {
    staticStyle: {
      "padding-bottom": "45px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.authorized()) ? _c('v-footer', {
    staticClass: "footer elevation-5",
    attrs: {
      "fixed": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('key-foot'), _vm._v(" "), _c('v-flex', [_vm._v("Powered by Triinfo Solutions s.r.o.")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6e8636a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1098
// module chunks = 1